import { createTheme } from '@mui/material/styles';

const sizes = {
  font: {
    8: '8px',
    12: '12px',
    16: '16px',
    18: '18px',
    20: '20px',
    32: '32px',
    48: '48px',
  },
  fields: {
    default: '50px',
  },
};

export const theme = createTheme({
  palette: {
    primary: {
      main: '#6A4192',
      success: '#2e7d32',
      error: '#d32f2f',
      warning: '#ED7D2C',
    },
    gradient_end: '#005E9B',
  },
  typography: {
    fontFamily: 'Moscow sans',
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': { fontSize: 32 },
          'color': '#A1ABBC',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: sizes.font[20],
          height: sizes.fields.default,
          textTransform: 'none',
          minWidth: '50px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
    },
    // Отключает дерганье названия поля
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiInput: {
      defaultProps: {
        margin: 'none',
      },
      styleOverrides: {
        backgroundColor: 'rgba(0, 37, 69, 0.05)',
        root: {
          height: sizes.fields.default,
          borderRadius: '5px',
          backgroundColor: 'rgba(0, 37, 69, 0.05)',
          padding: '13px 30px 13px 30px',
          ['label + &']: {
            marginTop: '28px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          height: '29px',
          padding: '5px 10px',
        },
        label: {
          padding: 0,
        },
        deleteIcon: {
          margin: 0,
          marginLeft: '9px',
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.8);',
        },
      },
    },
    sizes,
  },
});
